import { createSelector } from 'reselect';
import { CRUDSelectors } from '../crudCreator/selectors';
import { MODEL_NAME } from './actions';

const getConfigStatus = state => state.config?.data?.orderStatus;
const getOrderHistories = state => state.orders?.orderHistories;

export const getOrderHistoriesSelectors = createSelector(
  [getConfigStatus, getOrderHistories],
  (statuses, orderHistories) => {
    return orderHistories?.map(orderHistory => statuses?.find(status => status.value === orderHistory.status) ?
      {
        ...orderHistory,
        ...statuses?.find(status => status.value === orderHistory.status),
      }
      : {
        color: "#ddd",
        text: orderHistory.status,
        value: orderHistory.status,
      })
    // return intersectionBy(statuses, orderHistories, data => data?.value || data?.status)
  }
);


export const ordersSelectors = new CRUDSelectors(MODEL_NAME);
